module.exports = __webpack_public_path__ + "img/jaye-kang-secret-of-foxes.1a135ba.jpg";